var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FullMasterTemplate',[_c('div',{attrs:{"id":"inner-wrap"}},[_c('div',{staticClass:"sub-content-full-space",class:{ 'width-max-content': _vm.maxContent }},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }